import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {PostbackService} from '../../../../../services/postback/postback.service';
import {Postback} from '../../../../../models/postback/postback';
import { DatePipe } from '@angular/common';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-postback-list',
  imports: [
    RouterLink,
    DatePipe
],
  templateUrl: './postback-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './postback-list.component.scss'
})
@MetaTitle('Postbacks')
export class PostbackListComponent implements OnInit {

  protected postbacks: Postback[] = [];

  constructor(private readonly postbackService: PostbackService) {
  }

  ngOnInit(): void {
    this.postbackService.findAll({groups: 'goal,offers'}).subscribe((postbacks: Postback[]) => {
      this.postbacks = postbacks;
    });
  }


}
